import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-titel-und-beschreibung-setzen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentTitelUndBeschreibungSetzenEffects {

    IncidentTitelUndBeschreibungSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_TITEL_UND_BESCHREIBUNG_SETZEN),
        mergeMap((x: ac.PostIncidentTitelUndBeschreibungSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentTitelUndBeschreibungSetzen(x.incidentBeschreibungRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentTitelUndBeschreibungSetzenErfolgreichAction(result, x.incidentBeschreibungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentTitelUndBeschreibungSetzenFehlerAction(error, x.incidentBeschreibungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
